<template>
  <div class="mx-auto max-w-md">
    <div class="flex justify-between">
      <template v-for="(title, index) in titles" :key="index + '-label'">
        <div
          v-if="index !== 0"
          :key="index + '-separator'"
          class="border-vgstone-500 borderLine mx-2 mt-4 w-full md:mx-5"
          :class="{
            'border-vgstone-500/30': currentStep < index + 1,
          }"
        ></div>
        <div class="grid-col grid">
          <button
            class="mx-auto rounded-full border-2 border-solid font-bold"
            :class="{
              'bg-vgwhite border-vgorange h-12 w-12 text-white shadow':
                currentStep === index + 1,
              'bg-vgorange border-vgorange h-10 w-10 text-white':
                currentStep > index + 1,
              'text-vgstone-500 h-10 w-10 border-white bg-white':
                currentStep < index + 1,
            }"
            @click="changCurrentStep(index)"
          >
            <span
              :class="{
                'text-white': currentStep > index + 1,
                'text-vgorange': currentStep === index + 1,
                'text-vgstone-500': currentStep < index + 1,
              }"
            >
              {{ index + 1 }}</span
            >
          </button>
          <label
            class="pt-3 text-center font-semibold leading-4 md:-mx-12"
            :class="{
              'text-vgorange text-sm': currentStep === index + 1,
              'text-vgorange text-xs': currentStep > index + 1,
              'text-vgstone-500 text-xs': currentStep < index + 1,
            }"
          >
            {{ title }}
          </label>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { mapStores } from 'pinia';
import { useCheckoutStore } from '@/stores/checkout';

export default {
  name: 'StepProgress',
  props: {
    titles: {
      type: Array,
      required: true,
    },
    currentStep: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      serviceSelectionSteps: ['requirements', 'roles', 'hours', 'candidates'],
      errorMessage: {
        0: 'Select roles, skills and tools to move forward.',
        1: 'Select roles to move forward.',
        2: 'Press next and select hours to move forward.',
      },
    };
  },
  computed: {
    ...mapStores(useCheckoutStore),
  },
  methods: {
    async changCurrentStep(index) {
      let ceilIndex = 0;

      if (
        [
          ...(this.checkoutStore.matchingCriteria?.keywords?.roles || []),
          ...(this.checkoutStore.matchingCriteria?.keywords?.skills || []),
          ...(this.checkoutStore.matchingCriteria?.keywords?.tools || []),
          ...(this.checkoutStore.matchingCriteria?.keywords?.default || []),
        ].flat()?.length !== 0
      ) {
        ceilIndex = 1;
      }
      if (
        this.checkoutStore.matchingCriteria?.rids &&
        this.checkoutStore.matchingCriteria?.rids?.length !== 0
      ) {
        ceilIndex = 2;
      }
      if (
        this.checkoutStore.matchingCriteria?.hours &&
        this.checkoutStore.matchingCriteria?.hours?.length !== 0 &&
        this.checkoutStore.matchingCriteria?.rids?.length ===
          this.checkoutStore.matchingCriteria?.hours?.length
      ) {
        ceilIndex = 3;
      }
      if (index <= ceilIndex) {
        await this.checkoutStore.updateMatchingCriteria({
          ...this.checkoutStore.matchingCriteria,
          step: this.serviceSelectionSteps[index],
        });
        this.$router
          .push({
            query: {
              ...this.$route.query,
              step: this.serviceSelectionSteps[index],
            },
          })
          .catch(() => {});
      } else {
        this.$root.$snackbar.error(
          `Cant go forward. ${this.errorMessage[ceilIndex] || ''}`
        );
      }
    },
  },
};
</script>
<style scoped>
.shadow {
  box-shadow: 0px 3px 4px;
  color: #a9a8d4;
}
.borderLine {
  border-top-width: 1px;
}
</style>
